module.exports = __webpack_public_path__ + "static/media/B5.fc43e950.webp";